module.exports = __webpack_public_path__ + "img/AudioInc.6ef73c02.png";